import styled from 'styled-components';
import { lighten } from 'polished';

interface ITabContentProps {
  index: number;
}

export const MainContent = styled.main`
  padding: 2.8rem 2.8rem;
  font-size: var(--font-size);
`;

export const MainContentHeader = styled.header`
  font-size: 1rem;
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
  gap: 1rem;

  > svg {
    margin-right: 0.88rem;
  }

  h1 {
    font-family: 'RedHatDisplay-Extrabold';
    color: #1e88e5;
    font-size: 2rem;
    line-height: 2.55rem;
    margin-right: 0.88rem;
  }

  > div > svg {
    display: block;
    margin: auto;
    position: relative;
    cursor: pointer;
    transition: stroke 0.3s;
  }

  > div > svg {
    stroke: ${lighten(0.16, '#63646A')};

    &:hover {
      stroke: #63646a;
    }
  }

  p {
    font-family: 'MarkPro';
    font-size: 1rem;
    line-height: 1.44rem;
    margin-left: 1.88rem;
  }
`;

export const NavigationMenu = styled.div`
  padding-top: 3vh;

  .profile-navBar {
    background: none;
    border: 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
    box-shadow: none;
    margin-bottom: 6.11vh;
  }

  .profile-tabs-container {
    overflow: visible !important;
  }

  .MuiTabs-scroller.MuiTabs-fixed {
    overflow: visible !important;
  }

  .profile-tab-item {
    margin-right: 3.22rem;
    > span {
      font-family: 'RedHatDisplay-Regular';
      font-size: 1.22rem;
      color: #000 !important;
      text-transform: none;
    }
  }
`;

export const TabContent = styled.div<ITabContentProps>`
  width: 100px;
  height: 100px;
  background: ${props =>
    // eslint-disable-next-line no-nested-ternary
    props.index === 0 ? 'black' : props.index === 1 ? 'red' : 'blue'};
`;
